export default __webpack_public_path__ + "static/media/FMC-logoFMC-Color-horizontal@2x.080bc1f9.png";